import React from 'react';
import axios from "axios";

const SignupStart = ({ prevStep, nextStep, setStep, apartment, handleChange, values, focusedTitleRef }) => {
    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

	const Previous = e => {
        e.preventDefault();
        prevStep();
    }

    const Back = e => {
        e.preventDefault();
        setStep(0);
    }

    return (
        <section>
			<div className="article-categories">
				<a href={`/wohnung/?id=${apartment.apartmentId}`} className="article-category">{apartment.title}</a>
			</div>

			<h1 ref={focusedTitleRef} tabIndex="-1"><span>Teilnahme an der Auslosung</span></h1>
			<p>Weil die Nachfrage nach GWG-Wohnungen sehr gross ist, können wir nicht sämtliche Interessierte zur Wohnungsbesichtigung einladen. Die Besichtigungstermine werden ausgelost.</p>
			<p>Wenn Sie an einer Wohnung interessiert sind, füllen Sie bitte das Formular aus. Wir informieren Sie nach der Auslosung, ob Sie an der Besichtigung dabei sind oder nicht.</p>
			<h3>Wichtig:</h3>
			<div className="custom-list-items">
				<ul>
					<li>Bitte füllen Sie das Formular pro Haushalt <b>nur einmal</b> aus. Wer das Formular mehrmals ausfüllt, wird von der Auslosung ausgeschlossen.</li>
					<li className="text-primary">Wohnen Sie bereits bei der GWG, bekommen Sie bei der Auslosung immer einen Besichtigungstermin. Füllen Sie dafür bitte das Formular aus. Nach der Auslosung erhalten Sie die Terminbestätigung.</li>
				</ul>
			</div>

			<button onClick={ Continue } className="btn btn-secondary">Teilnehmen</button>
        </section>
    )

}

export default SignupStart
